import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

import Icon from "./icon"

const ArrowizedWrapper = styled.div`
  a {
    color: var(--pacific-blue);
    /* font-size: 20px;
    line-height: 28px; */
    font-family: "Source Sans Pro";
    text-decoration: none;
    display: flex;
    span {
      font-size: 20px;
      line-height: 28px;
      /* height: 28px; */
      color: var(--pacific-blue);
      margin-right: 16px;
    }
    svg {
      transition: 0.3s ease-in-out;

      width: 28px;
      height: 28px;
      stroke: var(--pacific-blue);
    }
    :hover {
      color: var(--pacific-blue);
      text-decoration: underline;
      svg {
        transform: translateX(12px);
      }
    }
  }
`

const ArrowizedLink = props => {
  return (
    <ArrowizedWrapper className={props.className && props.className}>
      <Link to={props.linkTo}>
        <span>{props.linkText}</span>
        <Icon icon="arrowized" />
      </Link>
    </ArrowizedWrapper>
  )
}

export default ArrowizedLink
